import { Paper, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ProductCardSmall({ product }) {
    const navigate = useNavigate();

    return (
        <Paper
            onClick={() => navigate(`/produto/${product.id}`)}
            sx={{
                width: 200,
                p: 2,
                borderRadius: "16px",
                cursor: "pointer",
                transition: "0.25s",
                "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                },
            }}
        >
            <Box
                sx={{
                    height: 120,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 1,
                }}
            >
                <img
                    src={product.imagens?.[0]}
                    alt={product.nome}
                    style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                />
            </Box>

            <Typography sx={{ fontWeight: 700, fontSize: 14 }} noWrap>
                {product.nome}
            </Typography>

            <Typography sx={{ color: "var(--azul)", fontWeight: 700, mt: 0.5 }}>
                {product.precos?.promo || product.precos?.normal}
            </Typography>
        </Paper>
    );
}